import { Call } from "../../../types/payload"

export const getLastCall = ({ call }: any): Call | null => call?.lastCall
export const getCall = ({ call }: any): Call | null => call?.call
